// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0e4063fa","885":"4f33ad21"}[chunkId] + ".chunk.js";
};